export const DONATION_PROMPT_COOLDOWN_MS = 7 * 24 * 60 * 60 * 1000
// Default fallback fires after twice the cooldown without invitations
export const DONATION_DEFAULT_TRIGGER_MS = DONATION_PROMPT_COOLDOWN_MS * 2
export const DONATION_PROMPT_LOCK_TIMEOUT_MS = 5_000
export const DONATION_STREAK_MIN_DAYS = 7

export const DONATION_FIRST_SEEN_STORAGE_KEY = 'donationFirstSeenAt'
export const DONATION_LAST_PROMPT_STORAGE_KEY = 'lastDonationPromptAt'

export const DONATION_INVITE_MESSAGE =
  '¿Escribonauta te está ayudando a escribir? Puedes apoyar el desarrollo del proyecto con una donación voluntaria.'

export type DonationPromptTrigger =
  | 'export'
  | 'layout'
  | 'daily-goal'
  | 'streak'
  | 'default'
